<template>
    <!--formatter:off-->
    <div class="wrap">
        <div class="bx_back" @click="$router.back()">
            <a class="btn_back">{{$t('common_previousPage')}}</a>
        </div>

        <div class="bx_round_white card_news">
            <CoronaResponseResult
                v-if="showResult"
                :title="this.title"
                :is-pass="this.coronaCheckIsPass"
                :is-allow-edit="this.isAllowEdit"
                :is-web-view="this.isWebView"
                :need-notice-corona-response-result="this.needNoticeCoronaResponseResult"
                @editCoronaResponse="editCoronaResponse"
            />

            <div class="bx_card_news detail type2" v-if="showSurveyEdit">
                <div class="bx_top">
                    <div class="title_area">
                        <h2 class="tit_cont">{{title}}</h2>
                    </div>
                </div>

                <div class="bx_cont">
                    <div class="cont">
                        <form action="#" onsubmit="return false">
                            <fieldset>
                                <p>{{surveyDesc}}</p>
                                <div class="bx_survey info">
                                    <h3 class="title small">
                                        {{$t('common_survey')}}<span>{{$t('SurveyResponseDefault_totalQuestionCount', {count: questions.length})}}</span>
                                    </h3>
                                    <ul class="lst_cont">
                                        <li>
                                            <span class="title">{{$t('SurveyResponseState_responseTarget')}} :</span>
                                            <span class="txt"><span>{{receiverName}}</span></span>
                                        </li>
                                        <li>
                                            <span class="title">{{$t('SurveyResponseState_endDate')}} :</span>
                                            <span class="txt">{{endDateText}}</span>
                                        </li>
                                    </ul>
                                </div>

                                <legend>{{$t('SurveyResponseDefault_blind_surveyArea')}}</legend>
                                <ul class="survey_list">
                                    <li v-for="(question, index) in questions">
                                        <div class="bx_title">
                                            <strong class="title">
                                                <span class="num">{{index + 1}}.</span>
                                                {{question.title}}
                                            </strong>
                                            <p class="desc" v-if="question.questionDesc">{{question.questionDesc}}</p>
                                        </div>
                                        <ul class="answer_list chkbox">
                                            <li v-for="option in question.options">
                                                <span class="bx_checkbox">
                                                    <input type="checkbox" :id="question.questionNo + '_' + option.answerNo" name="que2"
                                                           class="input_chk"
                                                           :checked="isCheckedOption({questionNo: question.questionNo, answerNo: option.answerNo})"
                                                           @click="doCheckOption({questionNo: question.questionNo, answerNo: option.answerNo, isMultiCheck: question.isMultiCheck})"
                                                    >
                                                    <label :for="question.questionNo + '_' + option.answerNo"
                                                           class="input_chk_label">{{option.desc}}</label>
                                                </span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                                <div class="bx_btn" v-if="!isAfterPeriod">
                                    <button type="button" class="btn_st6" @click="submit">{{$t('SurveyResponseDefault_submit')}}</button>
                                </div>

                            </fieldset>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--formatter:on-->
</template>

<script>
import Nl2br from 'vue-nl2br';
import moment from 'moment';
import responseApi from '@common/apis/survey/responseApi.js';
import SimpleErrorMessage from '@common/views/SimpleErrorMessage.vue';
import CoronaResponseResult from '@iamschoolpc/components/response/CoronaResponseResult.vue';
import {toDateFromISOFormat, toDate년월일Format, toResponseViewFormat} from '@common/utils/date.js';
import {$showErrorPage} from '@common/utils/errorPage.js';
import {START_DATE_OF_SCHOL} from '@common/consts/corona.js';
import {$showAlert} from '@/iamteacherpc/utils/alertConfirm.js';

export default {
    name: 'CoronaResponse',
    components: {
        Nl2br,
        CoronaResponseResult,
    },

    data() {
        return {
            isLoading: false,
            showResult: false,
            showSurveyEdit: false,
            survey: {},
            surveyDesc: this.$t('CoronaResponse_desc'),
            receiverName: '',
            endDateText: '',

            questions: [
                ...this.getFixedQuestions(),
            ],
            pending: false,
        };
    },

    computed: {
        isWebView() {
            return this.$route.query.hasOwnProperty('isMasking');
        },

        wrapperStyle() {
            return this.isLoading ? {height: '100%'} : {};
        },

        title() {
            return this.$t('CoronaResponse_title', {date: toDate년월일Format(this.survey.startDate)});
        },

        isAfterPeriod() {
            const endDate = toDateFromISOFormat(this.survey.endDate);
            return Date.now() > endDate;
        },

        isAllowEdit() {
            const allowEditOption = this.survey.surveyOptions.find(option => option.optionType === 'ALLOW_EDIT');
            return !!(allowEditOption && allowEditOption.optionValue === 'true');
        },

        coronaCheckIsPass() {
            return this.questions.every(question => {
                return question.answers.length === 1 && question.answers[0].answerNo === '1';
            });
        },

        isAlreadyAnswer() {
            return this.survey.surveyReceivers[0].surveyAnswers.length !== 0;
        },

        /**
         * 진단결과 공개여부 (교육부 지침 학년별 등교일 일주일 전부터 공개)
         */
        needNoticeCoronaResponseResult() {
            const classType = this.survey.surveyReceivers[0].receiverOptions.find(option => option.optionType === 'FILTER_TAG').optionValue;
            return moment(this.survey.startDate)
                .isAfter(moment(START_DATE_OF_SCHOL[classType], 'YYYY-MM-DD')
                    .subtract(7, 'days'));
        },
    },

    methods: {
        /**
         * 문항 체크 여부
         * @param questionNo
         * @param answerNo
         * @returns {boolean}
         */
        isCheckedOption({questionNo, answerNo}) {
            const question = this.questions.find(q => q.questionNo === questionNo);
            return question.answers.findIndex(a => a.answerNo === answerNo) !== -1;
        },

        /**
         * 문항 체크 동작시
         * @param questionNo
         * @param answerNo
         * @param isMultiCheck
         */
        doCheckOption({questionNo, answerNo, isMultiCheck}) {
            const question = this.questions.find(q => q.questionNo === questionNo);
            if (this.isCheckedOption({questionNo, answerNo})) {
                question.answers.splice(question.answers.findIndex(a => a.answerNo === answerNo), 1);
                return;
            }

            const selectedOption = question.options.find(o => o.answerNo === answerNo);
            if (isMultiCheck) {
                if (selectedOption.isOnlyOne) {
                    question.answers = [selectedOption];
                    return;
                }

                if (question.answers.some(a => a.isOnlyOne)) {
                    question.answers = question.answers.filter(a => !a.isOnlyOne);
                }
                question.answers.push(selectedOption);
            } else {
                question.answers = [selectedOption];
            }
        },

        /**
         * 제출하기
         * @returns {Promise<void>}
         */
        async submit() {
            if (this.pending) {
                return;
            }

            if (!this.validateAnswer({questions: this.questions})) {
                return;
            }

            try {
                this.pending = true;
                await responseApi.postSurveyAnswers({
                    surveyNo: this.survey.surveyNo,
                    request: this.makeSubmitRequest(),
                });

                window.scrollTo(0, 0);
                this.showSurveyEdit = false;
                this.isLoading = true;
                await setTimeout(() => {
                    this.isLoading = false;
                    this.showResult = true;
                }, 1000);
            } catch (err) {
                window.alert(err.message);
            } finally {
                this.pending = false;
            }
        },

        validateAnswer({questions}) {
            if (this.isAlreadyAnswer && !this.isAllowEdit) {
                window.alert(this.$t('CoronaResponse_notAllowEdit'));
                return false;
            }

            for (let i = 0; i < questions.length; i++) {
                if (questions[i].answers.length === 0) {
                    window.alert(this.$t('CoronaResponse_pleaseAnswer', {number: i + 1}));
                    return false;
                }
            }
            return true;
        },

        makeSubmitRequest() {
            const surveyReceiverNo = this.survey.surveyReceivers[0].surveyReceiverNo;
            const surveyAnswers = this.questions.map(question => {
                return {
                    questionNo: question.questionNo,
                    answers: question.answers.map(answer => {
                        return {
                            answerNo: answer.answerNo,
                            answer: answer.desc,
                        };
                    }),
                };
            });

            return {
                surveyReceiverNo,
                surveyAnswers,
            };
        },

        async setInitSurvey() {
            try {
                this.survey = await this.getRequestInfo();
                this.receiverName = this.survey.surveyReceivers[0].receiverName;
                this.endDateText = toResponseViewFormat(this.survey.endDate);
            } catch (e) {
                if (e instanceof Error) {
                    console.log(e);
                    e.message = this.$t('common_scriptError');
                }

                $showErrorPage({component: SimpleErrorMessage, payload: {message: e.message}});
            }
        },

        /**
         * 응답화면 로드 시 필요한 초기정보
         * @returns {Promise<AxiosResponse<T>>}
         */
        async getRequestInfo() {
            let {surveyReferenceNo, r, serviceId, isMasking} = this.$route.query;
            isMasking = isMasking !== 'false';
            return await responseApi.getSurveyAnswer({
                surveyReferenceNo,
                receiverReferenceNo: r,
                provider: serviceId.toUpperCase(),
                isMasking: !!isMasking,
            });
        },

        setAnswers() {
            const alreadySelectedAnswers = this.survey.surveyReceivers[0].surveyAnswers;
            alreadySelectedAnswers.forEach(answer => {
                const question = this.questions.find(q => q.questionNo === answer.questionNo);
                question.answers.push(question.options.find(o => o.answerNo === answer.answerNo + ''));
            });
        },

        editCoronaResponse() {
            window.scrollTo(0, 0);
            this.showSurveyEdit = true;
            this.showResult = false;
        },

        //자가진단 고정 질문
        getFixedQuestions() {
            return [
                {
                    questionNo: '20201',
                    title: this.$t('CoronaResponse_2103_q1'),
                    questionDesc: this.$t('CoronaResponse_2103_q1_desc'),
                    isMultiCheck: false,
                    options: [
                        {answerNo: '1', desc: this.$t('CoronaResponse_2103_q1_a1')},
                        {answerNo: '2', desc: this.$t('CoronaResponse_2103_q1_a2')},
                    ],
                    answers: [],
                },
                {
                    questionNo: '20202',
                    title: this.$t('CoronaResponse_2103_q2'),
                    isMultiCheck: false,
                    options: [
                        {answerNo: '1', desc: this.$t('CoronaResponse_2103_q2_a1')},
                        {answerNo: '2', desc: this.$t('CoronaResponse_2103_q2_a2')},
                    ],
                    answers: [],
                },
                {
                    questionNo: '20203',
                    title: this.$t('CoronaResponse_2103_q3'),
                    questionDesc: this.$t('CoronaResponse_2103_q3_desc'),
                    isMultiCheck: false,
                    options: [
                        {answerNo: '1', desc: this.$t('CoronaResponse_2103_q3_a1')},
                        {answerNo: '2', desc: this.$t('CoronaResponse_2103_q3_a2')},
                    ],
                    answers: [],
                },
            ];
        },
    },

    async created() {
        await this.setInitSurvey();
        if (this.isAfterPeriod) {
            $showAlert({
                title: this.$t('CoronaResponse_answerTimeExpired'),

            });
        }

        if (this.isAlreadyAnswer) {
            this.setAnswers();
            this.showResult = true;
            return;
        }

        this.showSurveyEdit = true;

        const {surveyNo, surveyReceivers} = this.survey;
        if (!surveyReceivers[0].readDate) {
            // 읽음처리 API는 응답을 기다리지 않음
            responseApi.patchSurveyReceiverRead({
                surveyNo,
                surveyReceiverNo: surveyReceivers[0].surveyReceiverNo,
            });
        }
    },
};
</script>
